import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { Icon } from 'iovisit-theme/components';
import { RichText } from 'iovisit-theme/components/Views';
import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  view_more_banner: { id: 'view_more_banner', defaultMessage: 'Scopri di più' },
});

const ArtworkBannerNotice = ({ content }) => {
  const intl = useIntl();

  const titleLink = content.notice_link_title
    ? content.notice_link_title
    : intl.formatMessage(messages.view_more_banner);

  const noticeText = RichText({
    content: content.notice_text,
    className: 'description',
  });

  return (
    (noticeText || content.notice_link) && (
      <Plug pluggable="banner-notice" id="page-header">
        <div id="artwork-banner-notice">
          <Container>
            {noticeText}
            {content.notice_link && (
              <div className="link">
                <UniversalLink href={content.notice_link} title={titleLink}>
                  {titleLink}
                  <Icon prefix="fas" icon="arrow-right" className="icon" />
                </UniversalLink>
              </div>
            )}
          </Container>
        </div>
      </Plug>
    )
  );
};

export default ArtworkBannerNotice;
